import React from 'react';
import { Controller } from 'react-hook-form';
import { FormFeedback, Input, Label } from 'reactstrap';

const formatCurrency = (value) => {
  if (typeof value === 'number') {
    value = value.toString();
  }
  if (!value) return '';
  const numberValue = Number(value.replace(/[^0-9.-]+/g, ""));
  return numberValue.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  }).replace(/\D00(?=\D*$)/, '');
};

const unformatCurrency = (value) => {
  return value.replace(/[^0-9.]+/g, '').replace(/(\..*)\./g, '$1');
};

const InputCurrency = ({
  label,
  options,
  control,
  errors,
  disabled = false,
}) => {
  // Reformatear ($, comas) en cada tecla rompe la edición de decimales: al
  // escribir "180." el valor se interpreta como "180.00" y se recorta a
  // "180" antes de poder teclear los centavos, pegándose como enteros
  // (180.61 -> 18,061). Mientras se edita se muestra el valor crudo tal cual
  // se escribe; el formato con $ y comas se aplica solo al salir del campo.
  const [isFocused, setIsFocused] = React.useState(false);
  return (
    <React.Fragment>
      <Label className="form-label" for={options.id}>
        {label}
      </Label>
      <Controller
        id={options.id}
        name={options.name}
        control={control}
        render={({ field }) => (
          <Input
            invalid={!!errors[options.name]}
            {...field}
            placeholder=""
            type="text"
            required={options.required || false}
            disabled={disabled}
            onChange={(e) => {
              const rawValue = unformatCurrency(e.target.value);
              field.onChange(rawValue);
            }}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              field.onBlur(e);
            }}
            value={isFocused ? (field.value ?? '') : formatCurrency(field.value)}
          />
        )}
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name]?.message}</FormFeedback>
      )}
    </React.Fragment>
  );
};

export default InputCurrency;
